import { z } from "zod";
import { artistLinkPageSlugSchema } from "@libs/link-in-bio-config";

// Compatibility for old integrations at /platform/streams only.
const MAX_SONG_DURATION_SECONDS = 24 * 60 * 60;

export const streamEventRequestSchema = z.object({
  songId: z.string().min(1),
  playbackId: z.string().uuid(),
  streamTime: z.number().positive().max(MAX_SONG_DURATION_SECONDS),
  songDuration: z.number().positive().max(MAX_SONG_DURATION_SECONDS),
  complete: z.boolean(),
  artistSlug: artistLinkPageSlugSchema.optional(),
  countryCode: z.string().length(2).optional(),
  // Correlates logged-out playback sessions. Required for partner-key
  // (anonymous) reporting; ignored for user-token reporting.
  anonymousId: z.string().uuid().optional(),
  // Client-side capture time of the chunk (the event may be flushed later).
  capturedAt: z.string().datetime().optional(),
});
export type StreamEventRequest = z.infer<typeof streamEventRequestSchema>;

export const streamEventResponseSchema = z.object({
  success: z.literal(true),
});
export type StreamEventResponse = z.infer<typeof streamEventResponseSchema>;

export const streamEventErrorSchema = z.object({
  error: z.enum([
    "unauthorized",
    "invalid_request",
    "session_already_complete",
    "song_not_found",
    "rate_limited",
  ]),
  reason: z.string().optional(),
});
export type StreamEventError = z.infer<typeof streamEventErrorSchema>;
